<template>
    <p class="notice-inner">{{item.content}}
        <a href="javscript:void(0)" @click.stop.prevent="$emit('toDetail',item.id)">查看详情</a>
    </p>
</template>
<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            }
        }
    };
</script>
<style lang="postcss">
.notice-inner {
  line-height: 1.5em;
  color: #60666e;
}
</style>
<style>
.tbo-notice-title {
  font-size: 16px !important;
}
</style>




// WEBPACK FOOTER //
// NoticeInnerLink.vue?17ee94cd